import React from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';

import ProductCard from 'modules/common/components/ProductCard';
import { formatCurrency } from 'modules/common/utils';

const renderItem = (label, value, className) => (
  <div className={cn('flex justify-between text-sm', className)}>
    <h4 className="text-gray-400 font-semibold">{label}</h4>
    <h4>{value}</h4>
  </div>
);

function OrderSummaryCard({ data }) {
  const {
    tax,
    remarks,
    discount,
    subtotal,
    delivery_fee,
    products = [],
    original_total,
  } = data;
  return (
    <div className="card">
      <h4 className="font-semibold">Item Ordered ({products?.length || 0})</h4>
      <div className="space-y-5">
        <div className="mt-3">
          <div className="grid gap-2 pr-2">
            {products?.map((item) => (
              <ProductCard
                key={item?.id}
                quantity={item?.quantity}
                label={item?.name}
                price={formatCurrency(item?.price)}
                description={
                  <>
                    {item?.addOns?.map((subItem) => (
                      <div key={subItem?.id}>
                        {subItem?.quantity || 0}x {subItem?.name} (+{' '}
                        {formatCurrency(subItem?.price)})
                      </div>
                    ))}
                  </>
                }
                imageSrc={item?.photo_url}
              />
            ))}
          </div>
        </div>
        <div>
          {renderItem(
            'Customer Remarks',
            remarks || 'N/A',
            'flex-col space-y-2'
          )}
          {/* {promo && (
              <div className="py-2">
                <div className="border-dashed border-2 border-primary-500 rounded p-3">
                  <h4 className="text-primary-500 font-bold">{promo?.code}</h4>
                  <h4 className="text-gray-400">{promo?.description}</h4>
                </div>
              </div>
            )} */}
        </div>
        <div className="grid gap-2 border-t border-b border-gray-200 py-5">
          {renderItem(
            'Subtotal',
            <span className="text-gray-500">{formatCurrency(subtotal)}</span>
          )}
          {renderItem(
            'Delivery Fee',
            <span className="text-gray-500">
              {formatCurrency(delivery_fee)}
            </span>
          )}
          {renderItem(
            'Tax',
            <span className="text-gray-500">{formatCurrency(tax)}</span>
          )}
          {renderItem(
            'Discount Coupon',
            <span className="text-gray-500">{formatCurrency(discount)}</span>
          )}
        </div>
        {renderItem(
          'Total',
          <span className="font-semibold">
            {formatCurrency(original_total)}
          </span>
        )}
      </div>
    </div>
  );
}
OrderSummaryCard.defaultProps = {};

OrderSummaryCard.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

export default OrderSummaryCard;
